export const PROHIBITED_LAYER_OPTIONS = [
  { id: 'audience_reactions', label: 'Audience reactions' },
  { id: 'audience_laughter', label: 'Audience laughter' },
  { id: 'applause', label: 'Applause' },
  { id: 'comedic_sfx', label: 'Comedic SFX' },
  { id: 'music', label: 'Music' },
  { id: 'ui_sounds', label: 'UI sounds' },
];

export const SFX_INTENSITY_VALUES = ['subtle', 'moderate', 'strong'];

export function shouldShowSoundPanel({ engineEnabled, hasPlan } = {}) {
  return Boolean(engineEnabled) && Boolean(hasPlan);
}

export function precisionDisplay(precision) {
  const key = String(precision || '').trim().toLowerCase();
  if (key === 'approximate') {
    return { key, label: 'unconfirmed', confirmed: false };
  }
  if (key === 'exact') {
    return { key, label: 'exact', confirmed: true };
  }
  if (key === 'line_level') {
    return { key, label: 'line_level', confirmed: false };
  }
  return { key: key || 'unconfirmed', label: key || 'unconfirmed', confirmed: false };
}

export function formatSoundMs(ms) {
  if (ms == null || ms === '') return '—';
  const n = Number(ms);
  if (!Number.isFinite(n)) return '—';
  return `${Math.round(n)} ms`;
}

export function capReachedMessage(error) {
  const text = typeof error === 'string'
    ? error
    : String(error?.detail || error?.message || error?.error || '');
  if (/generation cap reached/i.test(text)) return 'generation cap reached';
  return '';
}

export function sceneIdsFromEvents(events) {
  const ids = [];
  for (const event of events || []) {
    const id = String(event?.scene_id || '');
    if (id && !ids.includes(id)) ids.push(id);
  }
  return ids;
}
